import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType } from '@types'

import { createSupplier } from './api'

const useCreateSupplier = (onClose: () => void) => {
  const { t } = useTranslation()
  const tPreffix = 'supplier_modal.use_create_supplier.'

  const errorTypes = [
    'USER_ALREADY_EXISTING',
    'SAP_CODE_ALREADY_IN_USE',
    'TRADE_NAME_ALREADY_IN_USE',
  ]

  const queryClient = useQueryClient()

  const onSuccess = () => {
    notification.success({
      message: t(`${tPreffix}SUCCESS`),
    })
    queryClient.invalidateQueries(QUERY_KEYS.SUPPLIERS_ADMIN)
    onClose()
  }

  const { mutate, isLoading: isLoadingSupplier } = useMutation(createSupplier, {
    onSuccess,
    onError: (err: unknown) => {
      const error = err as AxiosErrorType

      const errorResponse = error.data.error as {
        type: string
        status: number
        message: string
      }

      if (errorTypes.includes(errorResponse.type)) {
        notification.error({
          message: t(`${tPreffix}${errorResponse.type}`),
        })
      } else {
        notification.error({
          message: t(`${tPreffix}ERROR`),
        })
      }
    },
  })

  return {
    createSupplier: mutate,
    isLoadingSupplier,
  }
}

export default useCreateSupplier
